<template>
  <div id="printed-modal">
    <b-container>
      <b-row>
        <b-col
          v-for="document in documents"
          :key="document.id"
        >
          <b-button
            block
            class="printed-btn"
          >
            พิมพ์{{ document.document_name }}
          </b-button>
        </b-col>
        <b-col>
          <b-button
            class="pdf-download-btn"
          >
            ดาวน์โหลดเป็น PDF
          </b-button>
        </b-col>
      </b-row>
      <b-row class="text-center mt-5 pt-5">
        <b-col><p>ตัวอย่างเอกสาร</p> </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
    name: "DocumentPrintedModal",
    props: {
        documents: {
            type: Array
        }
    }
};
</script>

<style lang="scss" scoped>
.printed-btn {
    background-color: #fd881e;
    border: none;
    height: 100%;
}

.pdf-download-btn {
    background-color: #2e83d9;
    border: none;
    height: 100%;
}
</style>
